// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"bp-z","slideIn":"cp-z"};